import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export function Skeleton({ className }) {
    return (_jsx("div", { role: "status", "aria-busy": "true", "aria-label": "Loading", className: cn('animate-shimmer rounded-lg', className) }));
}
export function TableSkeleton({ rows = 6, cols = 5 }) {
    return (_jsx(_Fragment, { children: [...Array(rows)].map((_, i) => (_jsx("tr", { children: [...Array(cols)].map((_, j) => (_jsx("td", { className: "px-4 py-3.5", children: _jsx(Skeleton, { className: cn('h-4', j === 0 ? 'w-3/4' : j === cols - 1 ? 'w-1/2' : 'w-full') }) }, j))) }, i))) }));
}
export function CardSkeleton({ lines = 3 }) {
    return (_jsxs("div", { className: "bg-white rounded-2xl border border-gray-100 p-5 shadow-sm space-y-3", children: [_jsx(Skeleton, { className: "h-3 w-24" }), _jsx(Skeleton, { className: "h-7 w-32" }), [...Array(lines - 2)].map((_, i) => (_jsx(Skeleton, { className: "h-3 w-20" }, i)))] }));
}
